import { Helmet } from "react-helmet";
const AdminDashboard = () => {
  return (
    <>
      <Helmet>
        <title>Admin Dashboard</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      {/* Following top-down UI architecture */}
      <div className="w-full h-full overflow-auto">
      <div className="px-6 py-6 transition-all duration-300"
   style={{
    paddingTop: 'calc(var(--navbar-height) + 1.5rem)', // Adds navbar height + existing py-6 (1.5rem)
  }}>
          <h1 className="text-3xl font-bold text-gray-800">Admin Dashboard</h1>
          <p className="text-gray-600 mt-2">Welcome to your administration dashboard</p>
          
          {/* Dashboard Overview */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Overall Stats Card */}
            <div className="p-6 rounded-lg" style={{ backgroundColor: 'var(--bg-secondary)', boxShadow: 'var(--shadow-box)' }}>
              <h2 className="text-xl font-semibold text-gray-800">System Overview</h2>
              <div className="mt-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">Total Users</span>
                  <span className="font-semibold">324</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">Active Today</span>
                  <span className="font-semibold">72</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Total API Calls</span>
                  <span className="font-semibold">15,429</span>
                </div>
              </div>
            </div>
            
            {/* Recent Activity Card */}
            <div className="bg-white p-6 rounded-lg shadow">
              <h2 className="text-xl font-semibold text-gray-800">Recent Activity</h2>
              <div className="mt-4 space-y-3">
                <div className="border-l-4 border-blue-500 pl-3">
                  <p className="text-sm text-gray-500">5 minutes ago</p>
                  <p className="text-gray-700">New user registered: John Doe</p>
                </div>
                <div className="border-l-4 border-green-500 pl-3">
                  <p className="text-sm text-gray-500">1 hour ago</p>
                  <p className="text-gray-700">Billing plan updated: Pro Plan</p>
                </div>
                <div className="border-l-4 border-yellow-500 pl-3">
                  <p className="text-sm text-gray-500">3 hours ago</p>
                  <p className="text-gray-700">System update completed</p>
                </div>
              </div>
            </div>
            
            {/* Quick Stats Card */}
            <div className="bg-white p-6 rounded-lg shadow">
              <h2 className="text-xl font-semibold text-gray-800">Usage Trends</h2>
              <div className="mt-4">
                <div className="flex flex-col mb-2">
                  <span className="text-gray-600 mb-1">API Usage</span>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: "70%" }}></div>
                  </div>
                </div>
                <div className="flex flex-col mb-2">
                  <span className="text-gray-600 mb-1">Storage</span>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-green-600 h-2.5 rounded-full" style={{ width: "45%" }}></div>
                  </div>
                </div>
                <div className="flex flex-col">
                  <span className="text-gray-600 mb-1">Bandwidth</span>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-purple-600 h-2.5 rounded-full" style={{ width: "30%" }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;